import React from 'react';
import styled from 'styled-components';

import { useConsentManagement } from 'src/utils/fides/hooks/use-consent-management';
import GlobalFooter from 'components/global-footer-rebrand';
import { DutchiePrivacyFooter } from 'src/dispensary/core-menu/components/dutchie-privacy-footer';

type LayoutWithoutHeaderProps = {
  children: React.ReactNode;
  hideFooter?: boolean;
};

export function LayoutWithoutHeader({ hideFooter, children, ...otherProps }: LayoutWithoutHeaderProps): JSX.Element {
  const { isConsentManagementEnabled } = useConsentManagement();

  return (
    <Container>
      {/* No GlobalHeader - intended for enterprise product views */}
      <Content {...otherProps}>{children}</Content>
      {isConsentManagementEnabled && <DutchiePrivacyFooter />}
      {!hideFooter && <GlobalFooter />}
    </Container>
  );
}

const Container = styled.main`
  display: flex;
  flex-direction: column;
  min-height: 100svh;
`;

export const Content = styled.div`
  flex: 1 0 0%;
`;
